<template>
  <div v-if="production_plan && production_plan.actions">
    <v-sheet class="pt-1 transparent-background-color d-inline-block">
      <v-tooltip
        top
        v-if="
          showView && $permission.permissionAllow('ProductionPlans', 'view')
        "
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            small
            dark
            color="info"
            class="px-2 me-2 mb-1"
            :href="'/#/production-plans/' + production_plan.id"
          >
            <v-icon x-small class="pe-1">fa-align-left</v-icon>
            {{ $t("Opt.details") }}
          </v-btn>
        </template>
        <span>{{
          $t("CRUD.viewInfo", [$t("ProductionPlans.ObjectName")])
        }}</span>
      </v-tooltip>
      <v-tooltip
        top
        v-if="
          showEdit && $permission.permissionAllow('ProductionPlans', 'edit')
        "
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            small
            dark
            color="primary"
            class="px-2 me-2 mb-1"
            @click.stop="
              $permission.checkAccountExpired().then(() => {
                detailMode
                  ? $emit('edit')
                  : $router.push(
                      '/production-plans/' + production_plan.id + '/edit'
                    );
              })
            "
          >
            <v-icon x-small class="pe-1">fa-pencil-alt</v-icon>
            {{ $t("ProductionPlans.actions.edit") }}
          </v-btn>
        </template>
        <span>{{ $t("ProductionPlans.actions.editProductionPlan") }}</span>
      </v-tooltip>
      <v-tooltip
        top
        v-if="
          showConfirm && $permission.permissionAllow('ProductionPlans', 'edit')
        "
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            small
            v-bind="attrs"
            v-on="on"
            dark
            color="print"
            class="px-2 me-2 mb-1"
            @click.stop="
              $permission.checkAccountExpired().then(() => {
                detailMode
                  ? $emit('confirm')
                  : $router.push(
                      '/production-plans/' +
                        production_plan.id +
                        '/edit/confirm'
                    );
              })
            "
          >
            <v-icon x-small class="pe-1">fa-location-arrow</v-icon>
            {{ $t("ProductionPlans.actions.confirm") }}
          </v-btn>
        </template>
        <span>{{ $t("ProductionPlans.actions.confirmProductionPlan") }}</span>
      </v-tooltip>
      <v-tooltip
        top
        v-if="
          showApprove && $permission.permissionAllow('ProductionPlans', 'edit')
        "
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            small
            dark
            color="action"
            class="px-2 me-2 mb-1"
            @click.stop="
              $permission.checkAccountExpired().then(() => {
                detailMode
                  ? $emit('approve')
                  : $router.push(
                      '/production-plans/' +
                        production_plan.id +
                        '/edit/approve'
                    );
              })
            "
          >
            <v-icon x-small class="pe-1">fa-stamp</v-icon>
            {{ $t("ProductionPlans.actions.approve") }}
          </v-btn>
        </template>
        <span>{{ $t("ProductionPlans.actions.approveProductionPlan") }}</span>
      </v-tooltip>
      <v-tooltip
        top
        v-if="
          showStockIN &&
          settings &&
          settings.stock_position_setting &&
          production_plan.stock &&
          production_plan.stock.wms_setting &&
          $permission.permissionAllow('StockIns', 'shelveOn')
        "
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            small
            dark
            color="action"
            class="px-2 me-2 mb-1"
            :href="
              '/#/putaway?stock_id=' +
              production_plan.stock_id +
              '&&stock_order_code=' +
              production_plan.stock_in.stock_order_code +
              '&&stock_in_type=4'
            "
          >
            {{ $t("ProductionPlans.actions.stockIN") }}
          </v-btn>
        </template>
        <span>{{ $t("ProductionPlans.actions.stockIN") }}</span>
      </v-tooltip>

      <v-tooltip
        top
        v-if="
          showStockIN &&
          settings &&
          ((settings.stock_position_setting &&
            production_plan.stock &&
            !production_plan.stock.wms_setting) ||
            !settings.stock_position_setting) &&
          $permission.permissionAllow('StockIns', 'in')
        "
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            small
            dark
            color="action"
            class="px-2 me-2 mb-1"
            :href="
              '/#/production-stock-in/' + production_plan.stock_in.id + '/in'
            "
          >
            {{ $t("ProductionPlans.actions.stockIN") }}
          </v-btn>
        </template>
        <span>{{ $t("ProductionPlans.actions.stockIN") }}</span>
      </v-tooltip>
      <v-tooltip
        top
        v-if="
          showStockOUT &&
          settings &&
          settings.stock_position_setting &&
          production_plan.stock &&
          production_plan.stock.wms_setting &&
          $permission.permissionAllow('StockOuts', 'out')
        "
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            small
            dark
            color="action"
            class="px-2 me-2 mb-1"
            :href="
              '/#/wave-generate?stock_id=' +
              production_plan.stock_id +
              '&&type=4'
            "
          >
            {{ $t("ProductionPlans.actions.stockOUT") }}
          </v-btn>
        </template>
        <span>{{ $t("ProductionPlans.actions.stockOUT") }}</span>
      </v-tooltip>
      <v-tooltip
        top
        v-if="
          showStockOUT &&
          settings &&
          ((settings.stock_position_setting &&
            production_plan.stock &&
            !production_plan.stock.wms_setting) ||
            !settings.stock_position_setting) &&
          $permission.permissionAllow('StockOuts', 'out')
        "
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            small
            dark
            color="action"
            class="px-2 me-2 mb-1"
            :href="
              '/#/production-stock-out/' + production_plan.stock_out.id + '/out'
            "
          >
            {{ $t("ProductionPlans.actions.stockOUT") }}
          </v-btn>
        </template>
        <span>{{ $t("ProductionPlans.actions.stockOUT") }}</span>
      </v-tooltip>
      <v-tooltip
        top
        v-if="
          showCancel && $permission.permissionAllow('ProductionPlans', 'cancel')
        "
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            small
            dark
            color="danger"
            class="px-2 me-2 mb-1"
            @click.stop="cancelAlert = true"
          >
            <v-icon x-small class="pe-1">fa-exclamation</v-icon>
            {{ $t("ProductionPlans.actions.cancel") }}
          </v-btn>
        </template>
        <span>{{ $t("ProductionPlans.actions.cancelProductionPlan") }}</span>
      </v-tooltip>
      <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            small
            dark
            color="print"
            class="px-2 me-2 mb-1 d-none"
          >
            <v-icon x-small class="pe-1">fa-file-export</v-icon>
            {{ $t("ProductionPlans.actions.export") }}
          </v-btn>
        </template>
        <span>{{
          $t("ProductionPlans.actions.productionPlanDetailExport")
        }}</span>
      </v-tooltip>
    </v-sheet>

    <DialogDelete
      v-model="cancelAlert"
      cancel-mode
      :label="$t('ProductionPlans.ObjectName')"
      :code="production_plan.production_code"
      @confirm="doAction('cancel')"
    />
  </div>
</template>

<script>
import { mapState } from "vuex";
import ProductionPlans from "@/api/production_plans";
import DialogDelete from "@/components/plugins/DialogDelete";

export default {
  name: "ProductionPlanActions",

  props: {
    production_plan: Object,
    detailMode: Boolean,
    showView: Boolean,
    showEdit: Boolean,
    showApprove: Boolean,
    showCancel: Boolean,
    showConfirm: Boolean,
    showStockIN: Boolean,
    showStockOUT: Boolean,
  },

  components: {
    DialogDelete,
  },

  computed: {
    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["settings", "accountUser"]),
  },

  data: () => ({
    printBtnMenu: false,
    exportBtnMenu: false,
    cancelAlert: false,
    executeUserSelected: null,
  }),

  methods: {
    actionMethod(mode) {
      if (mode == "cancel")
        return ProductionPlans.cancel(this.production_plan.id);
    },
    doAction(mode) {
      this.$permission.checkAccountExpired().then(
        function () {
          this.actionMethod(mode).then(
            function (response) {
              if (response.data.status.isOK()) {
                this.$emit("done");
              }
            }.bind(this)
          );
        }.bind(this)
      );
    },
    doPrint(mode) {
      this.$permission.checkAccountExpired().then(
        function () {
          console.log(mode);
          // TODO print
        }.bind(this)
      );
    },
  },

  watch: {
    accountUser: {
      immediate: true,
      handler() {
        this.executeUserSelected = this.accountUser ? this.accountUser : null;
      },
    },
  },
};
</script>